import React from 'react';
import PropTypes from 'prop-types';

export default function MapPriceMarker({ price }) {
  return (
    <div className="map-price-marker">{price ? `$${price}` : 'Inquire'}</div>
  );
}

MapPriceMarker.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
